const CHUNK_SIZE = 0x8000;

export function encodeExport(value: unknown): string {
    const bytes = new TextEncoder().encode(JSON.stringify(value));
    let binary = '';
    for (let i = 0; i < bytes.length; i += CHUNK_SIZE) {
        binary += String.fromCharCode(...bytes.subarray(i, i + CHUNK_SIZE));
    }
    return btoa(binary);
}

export function decodeExport(contents: string): string {
    const trimmed = contents.trim();
    if (trimmed.startsWith('{') || trimmed.startsWith('[')) return trimmed;

    const binary = atob(trimmed);
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    return new TextDecoder().decode(bytes);
}
